module.exports = __webpack_public_path__ + "static/media/purpleCheck.215189c7.svg";